import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', () => {
      // displays the CMP
      window.__tcfapi('show', 2, function() { });
    });
  }
}
